import {
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from './firebase';

const CONFIG_DOC = 'current';

function configRef(clubId) {
  return doc(db, 'clubs', clubId, 'fleet_config', CONFIG_DOC);
}

const EMPTY_CONFIG = {
  fleets: [],
  classes: [],
  start_locations: [],
};

export async function loadFleetConfig(clubId) {
  const snap = await getDoc(configRef(clubId));
  if (!snap.exists()) return { ...EMPTY_CONFIG };
  const data = snap.data();
  return {
    fleets: data.fleets ?? [],
    classes: data.classes ?? [],
    start_locations: data.start_locations ?? [],
  };
}

export async function saveFleetConfig(clubId, config) {
  await setDoc(configRef(clubId), {
    fleets: config.fleets,
    classes: config.classes,
    start_locations: config.start_locations,
    updated_at: serverTimestamp(),
  });
}
